export default __webpack_public_path__ + "static/media/grandma3M.e66ae5dd.jpg";